import script from "./AccessView.vue?vue&type=script&lang=ts&setup=true"
export * from "./AccessView.vue?vue&type=script&lang=ts&setup=true"

import "./AccessView.vue?vue&type=style&index=0&id=6f7bdad8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f7bdad8"]])

export default __exports__